// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"afefd28a","510":"26939806"}[chunkId] + ".chunk.js";
};